export const SUBJECTS = [
  { id: '数学', name: '数学', color: '#3b82f6' },
  { id: '语文', name: '语文', color: '#ef4444' },
  { id: '英语', name: '英语', color: '#10b981' },
  { id: '政治', name: '政治', color: '#f59e0b' },
  { id: '物理', name: '物理', color: '#8b5cf6' },
  { id: '化学', name: '化学', color: '#ec4899' },
]

export const ERROR_TYPES = [
  { id: 'A1', name: 'A1. 概念理解错误', category: '知识' },
  { id: 'A2', name: 'A2. 公式记忆错误', category: '知识' },
  { id: 'A3', name: 'A3. 知识点遗忘', category: '知识' },
  { id: 'A4', name: 'A4. 知识点混淆', category: '知识' },
  { id: 'A5', name: 'A5. 知识盲区', category: '知识' },
  { id: 'A6', name: 'A6. 原理理解不深', category: '知识' },
  { id: 'B1', name: 'B1. 解题思路错误', category: '思维' },
  { id: 'B2', name: 'B2. 方法选择不当', category: '思维' },
  { id: 'B3', name: 'B3. 步骤遗漏', category: '思维' },
  { id: 'B4', name: 'B4. 逻辑推理错误', category: '思维' },
  { id: 'B5', name: 'B5. 缺乏解题技巧', category: '思维' },
  { id: 'C1', name: 'C1. 运算错误', category: '计算' },
  { id: 'C2', name: 'C2. 符号错误', category: '计算' },
  { id: 'C3', name: 'C3. 单位换算错误', category: '计算' },
  { id: 'C4', name: 'C4. 数值代入错误', category: '计算' },
  { id: 'D1', name: 'D1. 题意理解错误', category: '审题' },
  { id: 'D2', name: 'D2. 条件遗漏', category: '审题' },
  { id: 'D3', name: 'D3. 关键词忽略', category: '审题' },
  { id: 'D4', name: 'D4. 题目看错', category: '审题' },
  { id: 'D5', name: 'D5. 隐含条件未挖掘', category: '审题' },
  { id: 'G1', name: 'G1. 粗心大意', category: '习惯' },
  { id: 'G2', name: 'G2. 思维定势', category: '习惯' },
  { id: 'G3', name: 'G3. 紧张慌乱', category: '习惯' },
]

export const TIME_BLOCKS = [
  { id: 'block_530', name: '5:30~6:00', start: '05:30', end: '06:00' },
  { id: 'block_600', name: '6:00~6:30', start: '06:00', end: '06:30' },
  { id: 'block_630', name: '6:30~7:00', start: '06:30', end: '07:00' },
  { id: 'block_700', name: '7:00~8:00', start: '07:00', end: '08:00' },
  { id: 'block_800', name: '8:00~9:00', start: '08:00', end: '09:00' },
  { id: 'block_910', name: '9:10~10:00', start: '09:10', end: '10:00' },
  { id: 'block_1000', name: '10:00~10:40', start: '10:00', end: '10:40' },
  { id: 'block_1040', name: '10:40~11:40', start: '10:40', end: '11:40' },
  { id: 'block_1140', name: '11:40~12:10', start: '11:40', end: '12:10' },
  { id: 'block_1210', name: '12:10~13:00', start: '12:10', end: '13:00' },
  { id: 'block_1305', name: '13:05~13:30', start: '13:05', end: '13:30' },
  { id: 'block_1335', name: '13:35~14:00', start: '13:35', end: '14:00' },
  { id: 'block_1400', name: '14:00~15:00', start: '14:00', end: '15:00' },
  { id: 'block_1500', name: '15:00~16:00', start: '15:00', end: '16:00' },
  { id: 'block_1600', name: '16:00~17:00', start: '16:00', end: '17:00' },
  { id: 'block_1700', name: '17:00~18:00', start: '17:00', end: '18:00' },
  { id: 'block_1800', name: '18:00~18:40', start: '18:00', end: '18:40' },
  { id: 'block_1840', name: '18:40~19:40', start: '18:40', end: '19:40' },
  { id: 'block_1950', name: '19:50~20:45', start: '19:50', end: '20:45' },
  { id: 'block_2100', name: '21:00~22:10', start: '21:00', end: '22:10' },
]

export const TARGET_SCORE = 688
export const GAOKAO_DATE = '2027-06-07'

export const getSubjectColor = (id) => SUBJECTS.find(s => s.id === id)?.color || '#6b7280'
